import React, { useState, useEffect } from "react";
import "./style.scss";
import OnboardHeading from "../../components/OnboardHeading";
import BackButtonComponent from "../../components/backButton";
import Loader from "../../components/Loader";
import { postData } from "../../api";
import { toast } from "react-toastify";
import { autocloseTiming } from "../../api/regex";

const HistoricalPayroll = () => {
  const [url, setUrl] = useState("");
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    getIframeData();
  }, []);
  const getIframeData = async () => {
    const data = {
      type: "external_payroll",
    };
    setLoader(true);
    const res = await postData("client-flow-link", {}, data);
    if (res.status === true) {
      const url = res?.data?.url;
      setUrl(url);
      setLoader(false);
    } else {
      toast.error(res.message, {
        theme: "colored",
        autoClose: autocloseTiming,
      });
      setLoader(false);
    }
  };
  return (
    <div className="payroll-history-container px-3 px-md-3 ">
      <OnboardHeading title="EXTERNAL PAYROLL" subtitle="Guhroo" />
      <BackButtonComponent reDirectionpath={`/settings`} />
      <div className="payroll-history-wrapper">
        <h2 className="payroll-history-title">External Payroll</h2>
        {loader ? (
          <Loader />
        ) : (
          <div className="payroll-history-iframe-wrapper">
            <iframe
              className="payroll-history-iframe"
              src={url}
              name="Iframe Payroll History"
              height="100%"
              width="100%"
              title="Iframe Example"
            ></iframe>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoricalPayroll;
